export default "__VITE_ASSET__CbgEh3U0__"